import React from 'react'

const LEAF_OUTLINE =
  'M50,2 L55,14 L60,11 L62,26 L72,18 L70,34 L84,31 L78,44 L97,52 L80,60 L84,72 L66,68 L62,78 L53,74 L52,98 L48,98 L47,74 L38,78 L34,68 L16,72 L20,60 L3,52 L22,44 L16,31 L30,34 L28,18 L38,26 L40,11 L45,14Z'
const LEAF_VEINS =
  'M50 96 L50 30 M50 70 L26 54 M50 70 L74 54 M50 50 L33 38 M50 50 L67 38'

const Leaf = ({ fill, stroke, className }) => (
  <svg className={className} viewBox="0 0 100 100" focusable="false">
    <path
      d={LEAF_OUTLINE}
      fill={fill}
      stroke={stroke}
      strokeWidth="1"
      strokeLinejoin="round"
    />
    <path
      d={LEAF_VEINS}
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinecap="round"
      fill="none"
      opacity="0.7"
    />
  </svg>
)

const Snowflake = ({ fill, className }) => (
  <svg className={className} viewBox="0 0 24 24" focusable="false">
    <g
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7" />
      <path d="M9.5 3.5L12 6l2.5-2.5M9.5 20.5L12 18l2.5 2.5" />
    </g>
  </svg>
)

// Cherry blossom petal: longer than wide, widest near the tip, with a shallow
// notch at the tip and a point at the base.
const PETAL_PATH =
  'M12 23 C9.4 19.4 6.4 14.6 6.8 9.6 C7 6.2 9.1 3 11 3.5 C11.7 3.7 11.95 4.6 12 5.6 C12.05 4.6 12.3 3.7 13 3.5 C14.9 3 17.1 6.2 17.2 9.6 C17.6 14.6 14.6 19.4 12 23Z'

const Petal = ({ fill, stroke, className }) => (
  <svg className={className} viewBox="0 0 24 24" focusable="false">
    <path
      d={PETAL_PATH}
      fill={fill}
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
)

const PARTICLE_SHAPES = {
  leaf: Leaf,
  snowflake: Snowflake,
  petal: Petal,
}

export default PARTICLE_SHAPES
